import { clearSlideStyles, disableEmblaScroll, slideNodesForSnap, stackTransform } from './embla-stack-helpers.js'

/**
 * Embla plugin that stacks every slide on top of the selected one and leaves the
 * opacity to CSS.
 *
 * embla-carousel-fade does the stacking too, but it also owns the opacity and
 * crossfades the outgoing slide against the incoming one (outgoing = 1 - incoming).
 * Halfway through, both are partially transparent and the background shows through.
 *
 * Here the plugin only kills the scroll translation and parks the slides on top of
 * each other. The component toggles `is-active` / `was-active`, so CSS can keep the
 * outgoing slide fully opaque underneath while the incoming one fades in above it.
 *
 * The slides no longer move, so give the carousel `watchDrag: false` — a drag would
 * have no visual feedback.
 */
export function StackFade() {
	let emblaApi

	function init(emblaApiInstance) {
		emblaApi = emblaApiInstance

		disableEmblaScroll(emblaApi)

		emblaApi.scrollSnapList().forEach((_, snapIndex) => {
			slideNodesForSnap(emblaApi, snapIndex).forEach((slideNode) => {
				slideNode.style.transform = stackTransform(emblaApi, snapIndex)
			})
		})
	}

	function destroy() {
		emblaApi.slideNodes().forEach((slideNode) => clearSlideStyles(slideNode, ['transform']))
	}

	return {
		name: 'stackFade',
		options: {},
		init,
		destroy,
	}
}
